import React, { createContext, useState, useContext, useEffect } from 'react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const LANGUAGES = [
  { code: 'en', name: 'English', flag: '🇬🇧' },
  { code: 'zh', name: '中文', flag: '🇨🇳' }
];

const LanguageContext = createContext({
  language: 'en',
  setLanguage: () => {},
  t: (text) => text
});

export const useLanguage = () => useContext(LanguageContext);

// Translation cache to avoid re-translating same text
const translationCache = {};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguageState] = useState(() => {
    return localStorage.getItem('neuro_language') || 'en';
  });
  const [translations, setTranslations] = useState({});

  const setLanguage = (lang) => {
    setLanguageState(lang);
    localStorage.setItem('neuro_language', lang);
  };

  // Get translation from cache or return original
  const t = (text) => {
    if (!text || language === 'en') return text;
    const key = `${language}:${text}`;
    return translations[key] || text;
  };

  // Translate and cache
  const translateAndCache = async (text) => {
    if (!text || language === 'en') return text;
    
    const key = `${language}:${text}`;
    if (translations[key]) return translations[key];

    try {
      const res = await fetch(`${API}/translate`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ text, target_language: language })
      });
      
      const data = await res.json();
      const translated = data.translated_text || text;
      
      setTranslations(prev => ({ ...prev, [key]: translated }));
      return translated;
    } catch (e) {
      return text;
    }
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t, translateAndCache }}>
      {children}
    </LanguageContext.Provider>
  );
};
